import {
  Header,
  Hero,
  VideoSection,
  Brotherhood,
  Benefits,
  Speakers,
  Schedule,
  Venue,
  BrotherhoodPledge,
  WaitlistSection,
  WealthSurvey,
  Pricing,
  FAQ,
  FinalCTA,
  Footer,
  ExitIntent,
  UrgencyBar
} from '../components/landing';
import { Toaster } from '../components/ui/sonner';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] noise-texture" data-testid="landing-page">
      {/* Toast notifications */}
      <Toaster position="top-center" richColors />
      
      {/* Exit Intent Popup */}
      <ExitIntent />
      
      {/* Sticky Header */}
      <Header />
      
      {/* Main Content */}
      <main>
        <Hero />
        <VideoSection />
        <Brotherhood />
        <Benefits />
        <Speakers />
        <Schedule />
        <Venue />
        <BrotherhoodPledge />
        <WealthSurvey />
        <WaitlistSection />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Mobile Urgency Bar */}
      <UrgencyBar />
    </div>
  );
}
